var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcBus = function SvgIcBus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_fleet",
    "data-name": "icon - fleet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.001,
    viewBox: "0 0 30 30.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_21",
    "data-name": "Exclusion 21",
    d: "M108,23H84a3,3,0,0,1-3-3V-4a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3V20A3,3,0,0,1,108,23ZM93,13.75h6v.75a.751.751,0,0,0,.75.75h.751a.751.751,0,0,0,.75-.75V13.165A2.253,2.253,0,0,0,102,11.5V4a2.466,2.466,0,0,0-1.757-2.484A12.653,12.653,0,0,0,96,1a12.657,12.657,0,0,0-4.244.516A2.466,2.466,0,0,0,90,4v7.5a2.253,2.253,0,0,0,.75,1.665V14.5a.751.751,0,0,0,.751.75h.75A.751.751,0,0,0,93,14.5v-.749Zm6.376-1.5a1.125,1.125,0,1,1,1.125-1.125A1.126,1.126,0,0,1,99.375,12.25Zm-6.75,0a1.125,1.125,0,1,1,1.125-1.125A1.126,1.126,0,0,1,92.625,12.25Zm7.875-4.5h-9V4h9V7.749Z",
    transform: "translate(-81 7)",
    fill: "#25556e"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcBus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_bus.77a5213b72dff24b98bad13206c09b0f.svg";